module.exports = __webpack_public_path__ + "static/media/downloadButton.d3099bd5.svg";